
$(".js-upload-button").click(function() {
	$(this).parent().find(".js-upload-object").click();
});

$(".js-upload-object").change(function(event){
	var $parent = $(this).closest("form");
    $parent.find(".js-upload-button").prop('value', $(this)[0].files[0].name);
    
	$parent.find(".nominee__label-container").toggle();
	$parent.find(".uploadButtonGroup :button").show();
	$parent.find(".nominee__icon--check").show();
});

$(".js-reset").click(function (event) {
	var $parent = $(this).closest("form");

	event.preventDefault();
	if ($parent.find(".js-upload-object")[0].files[0] != "undefined")
	{
		$parent.find('.js-upload-object').val('').clone(true);
		$parent.find('.js-upload-button').prop('value', '');
		$parent.find('.nominee__label-container').toggle();
		$parent.find('.uploadButtonGroup :button').hide();
		$parent.find('.nominee__icon--check').hide();
	}
});


// $('#uploadButton').click(function (event) {
//     $('#uploadObject').click();
// });

// $("#uploadObject").change(function(event){
//     $('#uploadButton').prop('value', $('#uploadObject')[0].files[0].name);
    
// 	$('.nominee__label-container').toggle();
// 	$('.uploadButtonGroup :button').show();
// 	$('.nominee__icon--check').show();
// });

// $('.reset').click(function (event) {
	
// 	event.preventDefault();
// 	if ($('#uploadObject')[0].files[0] != "undefined")
// 	{
// 		$('#uploadObject').val('').clone(true);
// 		$('#uploadButton').prop('value', '');
// 		$('.nominee__label-container').toggle();
// 		$('.uploadButtonGroup :button').hide();
// 		$('.nominee__icon--check').hide();
// 	}
// });

$('.nominee__edit-btn').click(function(){
	event.preventDefault();
	$('#wijzigGegevensForm').toggle();
	$('.nominee__details').toggle();
});

$('#annuleerWijzigGegevens').click(function(){
	event.preventDefault();
	$('#wijzigGegevensForm').toggle();
	$('.nominee__details').toggle();
});


// WEBPACK FOOTER //
// ./app/src/assets/js/partials/upload.js